<template>
  <div>
    <el-dialog
      title="行程明细"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
      append-to-body
      modal-append-to-body
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="140px" label-position="right">
        <!-- 表单内容 -->
        <el-row>
          <el-col :span="8">
            <el-form-item label="起始日期" prop="startDate">
              <el-date-picker
                v-model="form.startDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                :disabled="true"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="起始时间" prop="startTime">
              <el-time-picker
                v-model="form.startTime"
                placeholder="选择时间"
                value-format="HH:mm"
                format="HH:mm"
                style="width: 100%"
                :disabled="true"
              ></el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="起始地点" prop="startAdd">
              <el-input
                v-model="form.startAdd"
                placeholder="请输入起始地点"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="结束日期" prop="endDate">
              <el-date-picker
                v-model="form.endDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                :disabled="true"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结束时间" prop="endTime">
              <el-time-picker
                v-model="form.endTime"
                placeholder="选择时间"
                value-format="HH:mm"
                format="HH:mm"
                style="width: 100%"
                :disabled="true"
              ></el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="目的地" prop="endAdd">
              <el-input
                v-model="form.endAdd"
                placeholder="请输入目的地"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">交通费用</el-divider>
        <el-row>
          <el-col :span="8">
            <el-form-item label="飞机费用" prop="airAmt">
              <jh-number
                :decimalNumber="2"
                placeholder="请输入飞机费用"
                :isMoney="true"
                v-model="form.airAmt"
                :disabled="true"
              >
                <span slot="append">元</span>
              </jh-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="火车费用" prop="trainAmt">
              <jh-number
                :decimalNumber="2"
                placeholder="请输入火车费用"
                :isMoney="true"
                v-model="form.trainAmt"
                :disabled="true"
              >
                <span slot="append">元</span>
              </jh-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="其他费用" prop="otherAmt">
              <jh-number
                :decimalNumber="2"
                placeholder="请输入其他费用"
                :isMoney="true"
                v-model="form.otherAmt"
                :disabled="true"
              >
                <span slot="append">元</span>
              </jh-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="市内交通费用" prop="inCityAmt">
              <jh-number
                :decimalNumber="2"
                placeholder="请输入市内交通费用"
                :isMoney="true"
                v-model="form.inCityAmt"
                :disabled="true"
              >
                <span slot="append">元</span>
              </jh-number>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="examine-incity-amt">
            <el-form-item label="核准市内交通费用" prop="examineInCityAmt">
              <jh-number
                :decimalNumber="2"
                placeholder="请输入核准市内交通费用"
                :isMoney="true"
                v-model="form.examineInCityAmt"
                :disabled="readonly"
              >
                <span slot="append">元</span>
              </jh-number>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 财务调整费用区域 -->
        <div v-if="finance">
          <el-row>
            <el-col :span="8">
              <el-form-item label="调整飞机费" prop="cwAirAmt" class="finance-adjust-amt">
                <jh-number
                  :decimalNumber="2"
                  placeholder="请输入调整飞机费"
                  :isMoney="true"
                  v-model="form.cwAirAmt"
                >
                  <span slot="append">元</span>
                </jh-number>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="调整火车费用" prop="cwTrainAmt" class="finance-adjust-amt">
                <jh-number
                  :decimalNumber="2"
                  placeholder="请输入调整火车费用"
                  :isMoney="true"
                  v-model="form.cwTrainAmt"
                >
                  <span slot="append">元</span>
                </jh-number>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="finance">
              <el-form-item label="调整其他费用" prop="cwOtherAmt" class="finance-adjust-amt">
                <jh-number
                  :decimalNumber="2"
                  placeholder="请输入调整其他费用"
                  :isMoney="true"
                  v-model="form.cwOtherAmt"
                >
                  <span slot="append">元</span>
                </jh-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="调整市内交通费用" prop="cwInCityAmt" class="finance-adjust-amt">
                <jh-number
                  :decimalNumber="2"
                  placeholder="请输入调整市内交通费用"
                  :isMoney="true"
                  v-model="form.cwInCityAmt"
                >
                  <span slot="append">元</span>
                </jh-number>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <el-divider content-position="left">其他信息</el-divider>
        <el-row>
          <el-col :span="8">
            <el-form-item label="天数" prop="xcTs">
              <jh-number
                :decimalNumber="0"
                placeholder="请输入天数"
                v-model="form.xcTs"
                :disabled="true"
              ></jh-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请补贴" prop="btAmt">
              <jh-number
                :decimalNumber="2"
                placeholder="请输入补贴"
                :isMoney="true"
                v-model="form.btAmt"
                :disabled="true"
              >
                <span slot="append">元</span>
              </jh-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="核准补贴" prop="examineBtAmt" class="examine-bt-amt">
              <jh-number
                :decimalNumber="2"
                placeholder="请输入核准补贴"
                :isMoney="true"
                v-model="form.examineBtAmt"
                :disabled="readonly"
              >
                <span slot="append">元</span>
              </jh-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="发票总金额" prop="fpTotalAmt">
              <jh-number
                :decimalNumber="2"
                placeholder="自动计算"
                :isMoney="true"
                v-model="fpTotalAmt"
                :disabled="true"
              >
              </jh-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="住宿情况" prop="zsqk">
              <el-select
                v-model="form.zsqk"
                placeholder="请选择住宿情况"
                style="width: 100%"
                :disabled="true"
              >
                <el-option label="酒店" value="1"></el-option>
                <el-option label="项目组" value="2"></el-option>
                <el-option label="其他" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="宾馆同住人" prop="bgtzr">
              <el-input
                v-model="form.bgtzr"
                placeholder="请输入宾馆同住人"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="userType != '2'">
          <el-col :span="8">
            <el-form-item label="所属项目编号" prop="ssxmCode">
              <el-input
                v-model="form.ssxmCode"
                placeholder="请选择项目"
                readonly
                :disabled="true"
                @focus="showProjectDialog"
                style="cursor: pointer"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="showProjectDialog"
                  :disabled="true"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属项目名称" prop="ssxmName">
              <el-input v-model="form.ssxmName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="userType != '2'">
          <el-col :span="24">
            <el-form-item label="周末节假日说明" prop="zmjjrRemark">
              <el-input
                type="textarea"
                v-model="form.zmjjrRemark"
                placeholder="请输入周末节假日说明"
                :rows="3"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="特殊费用说明" prop="tsfyRemark">
              <el-input
                type="textarea"
                v-model="form.tsfyRemark"
                placeholder="请输入特殊费用说明"
                :rows="3"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="userType == '2'">
          <el-col :span="24">
            <el-form-item label="备注" prop="tsfyRemark">
              <el-input
                type="textarea"
                v-model="form.tsfyRemark"
                placeholder="请输入备注"
                :rows="3"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="invoice-header">
              <el-divider content-position="left">发票信息</el-divider>
              <el-button
                v-if="form.fpList && form.fpList.length > 0"
                type="success"
                size="small"
                @click="previewAllInvoices"
                >查看全部发票</el-button
              >
            </div>
            <div style="width: 100%; overflow-x: auto">
              <el-table :data="form.fpList || []" style="width: 100%" size="small" border>
                <el-table-column prop="fpNumber" label="发票号码" min-width="150"></el-table-column>
                <el-table-column
                  prop="fpTypeName"
                  label="发票类型"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  prop="fpCatName"
                  label="发票种类"
                  min-width="120"
                ></el-table-column>
                <el-table-column label="费用类型" min-width="120">
                  <template slot-scope="scope">
                    <el-tag :type="getFeeTypeTagType(scope.row.feeType)" size="small">
                      {{ getFeeTypeName(scope.row.feeType) }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="kpDate" label="开票日期" min-width="120">
                  <template slot-scope="scope">
                    {{ formatKpDate(scope.row.kpDate) }}
                  </template>
                </el-table-column>
                <el-table-column prop="fpAmt" label="金额" min-width="120" align="right">
                  <template slot-scope="scope"> {{ scope.row.fpAmt }}元 </template>
                </el-table-column>
                <el-table-column prop="fpRemark" label="备注" min-width="150"> </el-table-column>
                <el-table-column label="操作" min-width="120" align="center" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="text" @click="previewInvoice(scope.row)"> 预览 </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ readonly ? '关 闭' : '取 消' }}</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
        <el-button v-if="!readonly && hasNext" type="success" @click="submitAndNext"
          >确认并下一条</el-button
        >
      </div>
    </el-dialog>

    <!-- 项目选择弹窗 -->
    <el-dialog title="选择项目" width="80%" :visible.sync="dialogProject" :fullscreen="false">
      <XmList ref="xmList" @confirm="handleProjectConfirm" @cancel="dialogProject = false" />
    </el-dialog>

    <!-- 发票选择弹窗 -->
    <el-dialog title="选择发票" width="90%" :visible.sync="dialogInvoice" :fullscreen="false">
      <FpList
        ref="fpList"
        :selectedFpIds="excludedFpIds"
        :initialSelectedInvoices="form.fpList"
        @confirm="handleInvoiceConfirm"
        @cancel="dialogInvoice = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import XmList from '@/fpComponents/XmList.vue';
import FpList from '@/fpComponents/FpList.vue';

export default {
  name: 'ClbxXcCashierDialog',
  components: {
    XmList,
    FpList
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    ssxmCode: {
      type: String,
      default: ''
    },
    ssxmName: {
      type: String,
      default: ''
    },
    editData: {
      type: Object,
      default: () => null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hasNext: {
      type: Boolean,
      default: false
    },
    // 新增：外部传入已选发票ID，用于在发票列表中过滤
    excludedFpIds: {
      type: Array,
      default: () => []
    },
    userType: {
      type: String,
      default: '3'
    },
    // 是否为财务模式
    finance: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      dialogProject: false,
      dialogInvoice: false, // 发票选择弹窗
      currentInvoiceList: [], // 当前选择的发票列表
      projectOptions: [],
      form: {
        clbxxcId: '',
        clbxId: '',
        startDate: dayjs().format('YYYY-MM-DD'),
        startTime: '09:00:00',
        startAdd: '',
        endDate: dayjs().format('YYYY-MM-DD'),
        endTime: '18:00:00',
        endAdd: '',
        airAmt: 0,
        trainAmt: 0,
        otherAmt: 0,
        inCityAmt: 0,
        zsqk: '1',
        bgtzr: '',
        zsAmt: 0,
        xcTs: 1,
        btAmt: 0,
        totalAmt: 0,
        zmjjrRemark: '',
        tsfyRemark: '',
        ssxmCode: '',
        ssxmName: '',
        fpList: [], // 发票列表
        // 新增：核准字段
        examineBtAmt: 0,
        examineInCityAmt: 0,
        examine: '0',
        // 财务调整字段
        cwAirAmt: 0,
        cwTrainAmt: 0,
        cwOtherAmt: 0,
        cwInCityAmt: 0
      },
      rules: {
        startDate: [{ required: true, message: '请选择起始日期', trigger: 'change' }],
        endDate: [{ required: true, message: '请选择结束日期', trigger: 'change' }],
        xcTs: [{ required: true, message: '请输入天数', trigger: 'blur' }]
      }
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.initForm();
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val);
    },
    ssxmCode(val) {
      this.form.ssxmCode = val;
    },
    ssxmName(val) {
      this.form.ssxmName = val;
    },
    editData: {
      handler(val) {
        if (val) {
          this.form = { ...this.form, ...val };
        }
      },
      deep: true
    },
    // 监听各项费用变化，自动更新总金额
    autoCalculatedAmount: {
      handler(newVal) {
        // 如果用户没有手动输入总金额（为0），则自动更新
        if (parseFloat(this.form.totalAmt || 0) === 0) {
          this.form.totalAmt = newVal.toFixed(2);
        }
      },
      immediate: true
    }
  },
  computed: {
    // 自动计算的总金额
    autoCalculatedAmount() {
      return (
        parseFloat(this.form.airAmt || 0) +
        parseFloat(this.form.trainAmt || 0) +
        parseFloat(this.form.otherAmt || 0) +
        parseFloat(this.form.inCityAmt || 0) +
        parseFloat(this.form.zsAmt || 0) +
        parseFloat(this.form.btAmt || 0) +
        parseFloat(this.fpTotalAmt || 0)
      );
    },
    // 发票总金额
    fpTotalAmt() {
      if (!this.form.fpList || this.form.fpList.length === 0) {
        return 0;
      }
      return this.form.fpList
        .reduce((sum, invoice) => {
          return sum + parseFloat(invoice.amtSum || invoice.fpAmt || 0);
        }, 0)
        .toFixed(2);
    }
  },
  methods: {
    // 格式化开票日期
    formatKpDate(kpDate) {
      if (!kpDate) return '-';
      return dayjs(kpDate).format('YYYY-MM-DD');
    },
    initForm() {
      if (this.editData) {
        // 编辑模式
        this.form = {
          // 先设置默认值
          clbxxcId: '',
          clbxId: '',
          startDate: dayjs().format('YYYY-MM-DD'),
          startTime: '09:00:00',
          startAdd: '',
          endDate: dayjs().format('YYYY-MM-DD'),
          endTime: '18:00:00',
          endAdd: '',
          airAmt: 0,
          trainAmt: 0,
          otherAmt: 0,
          inCityAmt: 0,
          zsqk: '1',
          bgtzr: '',
          zsAmt: 0,
          xcTs: 1,
          btAmt: 0,
          totalAmt: 0,
          zmjjrRemark: '',
          tsfyRemark: '',
          ssxmCode: '',
          ssxmName: '',
          fpList: [],
          examineBtAmt: 0,
          examineInCityAmt: 0,
          examine: '0',
          // 财务调整字段
          cwAirAmt: 0,
          cwTrainAmt: 0,
          cwOtherAmt: 0,
          cwInCityAmt: 0,
          // 然后用编辑数据覆盖
          ...this.editData
        };
        // 若无核准值，默认等于原始值
        if (typeof this.form.examineBtAmt === 'undefined' || this.form.examineBtAmt === null) {
          this.form.examineBtAmt = this.form.btAmt;
        }
        if (
          typeof this.form.examineInCityAmt === 'undefined' ||
          this.form.examineInCityAmt === null
        ) {
          this.form.examineInCityAmt = this.form.inCityAmt;
        }
        // 确保编辑模式下保留clbxxcId
        console.log('编辑模式，clbxxcId:', this.form.clbxxcId);
      } else {
        // 新增模式
        this.form = {
          clbxxcId: '',
          clbxId: '',
          startDate: dayjs().format('YYYY-MM-DD'),
          startTime: '09:00:00',
          startAdd: '',
          endDate: dayjs().format('YYYY-MM-DD'),
          endTime: '18:00:00',
          endAdd: '',
          airAmt: 0,
          trainAmt: 0,
          otherAmt: 0,
          inCityAmt: 0,
          zsqk: '1',
          bgtzr: '',
          zsAmt: 0,
          xcTs: 1,
          btAmt: 0,
          totalAmt: 0,
          zmjjrRemark: '',
          tsfyRemark: '',
          ssxmCode: '',
          ssxmName: '',
          fpList: [], // 发票列表
          examineBtAmt: 0,
          examineInCityAmt: 0,
          examine: '0',
          // 财务调整字段
          cwAirAmt: 0,
          cwTrainAmt: 0,
          cwOtherAmt: 0,
          cwInCityAmt: 0
        };
      }
    },
    handleClose() {
      this.$refs.form && this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
    // 显示项目选择弹窗
    showProjectDialog() {
      if (this.readonly) return;
      this.dialogProject = true;
    },
    // 处理项目选择确认
    handleProjectConfirm(selectedProjects) {
      if (selectedProjects && selectedProjects.length > 0) {
        const selectedProject = selectedProjects[0]; // 取第一个选中的项目
        this.form.ssxmCode = selectedProject.xmCode;
        this.form.ssxmName = selectedProject.xmName;
      }
      this.dialogProject = false;
    },
    // 显示发票选择弹窗
    showInvoiceDialog() {
      this.dialogInvoice = true;
    },
    // 处理发票选择确认
    handleInvoiceConfirm(selectedInvoices) {
      if (selectedInvoices && selectedInvoices.length > 0) {
        // 映射发票数据字段，确保后端能正确接收
        const mappedInvoices = selectedInvoices.map((invoice) => ({
          fpId: invoice.fpid,
          fpNumber: invoice.fpNumber,
          fpAmt: invoice.amtSum,
          kpDate: invoice.kpRq,
          fpTypeName: invoice.fpTypeName,
          fpKind: invoice.fpKind || invoice.fpType || '', // 发票种类
          gfName: invoice.gfName,
          fpStatus: invoice.fpStatus,
          fileId: invoice.fileId,
          fpName: invoice.fpName,
          remark: invoice.remark || invoice.bz || '' // 备注信息
        }));

        this.form.fpList = mappedInvoices;
        // 更新总金额
        this.form.totalAmt = this.autoCalculatedAmount.toFixed(2);
      }
      this.dialogInvoice = false;
    },

    // 获取已选择的发票ID列表
    getSelectedFpIds() {
      if (!this.form.fpList || this.form.fpList.length === 0) {
        return [];
      }
      return this.form.fpList.map((fp) => fp.fpId);
    },
    // 使用自动计算的金额
    useAutoCalculated() {
      this.form.totalAmt = this.autoCalculatedAmount.toFixed(2);
    },
    submitForm() {
      // 如果是财务模式，调用财务保存接口
      if (this.finance) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.saveFinanceData();
          }
        });
        return;
      }

      // 如果是只读模式，则直接提交当前数据进行审核
      if (this.readonly) {
        const submitData = {
          ...this.form,
          examine: '1', // 设置审核状态为已审核
          examineBtAmt: this.form.examineBtAmt,
          examineInCityAmt: this.form.examineInCityAmt
        };
        this.$emit('submit', submitData);
        this.handleClose();
        return;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          // 如果用户没有手动输入总金额，则自动计算
          let finalTotalAmt = parseFloat(this.form.totalAmt || 0);
          if (finalTotalAmt === 0) {
            finalTotalAmt =
              parseFloat(this.form.airAmt || 0) +
              parseFloat(this.form.trainAmt || 0) +
              parseFloat(this.form.otherAmt || 0) +
              parseFloat(this.form.inCityAmt || 0) +
              parseFloat(this.form.zsAmt || 0) +
              parseFloat(this.form.btAmt || 0);
          }

          // 构建提交数据
          const submitData = {
            ...this.form,
            totalAmt: finalTotalAmt.toFixed(2)
          };

          // 保留临时ID，用于前端编辑跟踪
          if (this.editData && this.editData._tempId) {
            submitData._tempId = this.editData._tempId;
          }

          this.$emit('submit', submitData);
          this.handleClose();
        } else {
          return false;
        }
      });
    },
    // 财务保存数据方法
    saveFinanceData() {
      this.loading = true;

      // 构建财务保存数据，参考clbxApply.vue的数据结构
      const submitData = {
        // 行程明细信息
        clbxxcId: this.form.clbxxcId || '',
        // 财务调整字段
        cwAirAmt: parseFloat(this.form.cwAirAmt || 0),
        cwTrainAmt: parseFloat(this.form.cwTrainAmt || 0),
        cwOtherAmt: parseFloat(this.form.cwOtherAmt || 0),
        cwInCityAmt: parseFloat(this.form.cwInCityAmt || 0)
      };

      this.$api
        .post('/api/cwgl/clbx/finance/save', submitData)
        .then((res) => {
          this.loading = false;
          if (res && res.retHead && res.retHead.code === '0000000') {
            this.$message.success('财务调整保存成功');
            this.handleClose();
            // 通知父组件刷新数据
            this.$emit('financeSubmitSuccess');
          } else {
            this.$message.error(res.retHead?.message || '保存失败');
          }
        })
        .catch((error) => {
          console.error('财务保存失败:', error);
          this.loading = false;
          this.$message.error('保存失败，请稍后重试');
        });
    },
    /**
     * @description: 确认并下一条
     * @author: Junchi Zhao
     */
    submitAndNext() {
      if (!this.readonly) {
        const submitData = {
          ...this.form,
          examine: '1', // 设置审核状态为已审核
          examineBtAmt: this.form.examineBtAmt,
          examineInCityAmt: this.form.examineInCityAmt
        };
        this.$emit('submitAndNext', submitData);
        // 不关闭弹窗，等待父组件传入下一条数据
        return;
      }
    },
    getFileExtensionWithDot(filename) {
      if (!filename) return '';
      const lastDotIndex = filename.lastIndexOf('.');
      return lastDotIndex === -1 ? '' : filename.substring(lastDotIndex).toLowerCase();
    },
    previewInvoice(invoice) {
      if (!invoice.fileId) {
        this.$message.warning('发票文件ID不存在，无法预览');
        return;
      }

      // 收集发票ID
      const fpIds = invoice.fpId ? [invoice.fpId] : [];

      if (fpIds.length === 0) {
        this.$message.warning('没有有效的发票ID');
        return;
      }

      // 获取发票的行程单信息
      this.getXcdByFpIds(fpIds).then((xcdList) => {
        // 构建发票和行程单的预览文件数据
        const previewFiles = [];

        // 添加发票文件
        if (invoice.fileId) {
          previewFiles.push({
            label: invoice.aliases,
            id: invoice.fileId,
            url:
              this.getGlobalConfig().uploadURL +
              '/api/file/downloadFile' +
              '?fullfilename=' +
              invoice.fileId +
              this.getFileExtensionWithDot(invoice.aliases) +
              '&fileHashOrWholeFileId=' +
              invoice.fileId
          });
        }

        // 添加行程单文件
        if (xcdList && xcdList.length > 0) {
          xcdList.forEach((xcd, index) => {
            if (xcd.fileId) {
              previewFiles.push({
                label: xcd.fileName,
                id: xcd.fileId,
                url:
                  this.getGlobalConfig().uploadURL +
                  '/api/file/downloadFile' +
                  '?fullfilename=' +
                  encodeURIComponent(xcd.fileName) +
                  '&fileHashOrWholeFileId=' +
                  xcd.fileId
              });
            }
          });
        }

        if (previewFiles.length === 0) {
          this.$message.warning('没有可预览的文件');
          return;
        }

        // 执行预览
        this.executePreview(previewFiles);
      });
    },
    // 预览所有发票
    previewAllInvoices() {
      const fpList = Array.isArray(this.form.fpList) ? this.form.fpList : [];
      if (fpList.length === 0) {
        this.$message.warning('没有可预览的发票');
        return;
      }

      // 收集所有发票ID
      const allFpIds = fpList.filter((invoice) => invoice.fpId).map((invoice) => invoice.fpId);

      if (allFpIds.length === 0) {
        this.$message.warning('没有有效的发票ID');
        return;
      }

      // 获取所有发票的行程单信息
      this.getXcdByFpIds(allFpIds).then((xcdList) => {
        // 构建所有发票和行程单的预览文件数据，实现穿插预览
        const previewFiles = [];

        // 遍历每个发票，将发票和对应的行程单进行穿插添加
        fpList.forEach((invoice, index) => {
          // 先添加发票文件
          if (invoice.fileId) {
            previewFiles.push({
              label: invoice.aliases,
              id: invoice.fileId,
              url:
                this.getGlobalConfig().uploadURL +
                '/api/file/downloadFile' +
                '?fullfilename=' +
                invoice.fileId +
                this.getFileExtensionWithDot(invoice.aliases) +
                '&fileHashOrWholeFileId=' +
                invoice.fileId
            });
          }

          // 然后添加该发票对应的行程单文件
          if (xcdList && xcdList.length > 0) {
            // 找到fpid等于当前发票fpId的行程单
            const relatedXcdList = xcdList.filter((xcd) => xcd.fpid === invoice.fpId);
            relatedXcdList.forEach((xcd) => {
              if (xcd.fileId) {
                previewFiles.push({
                  label: xcd.fileName,
                  id: xcd.fileId,
                  url:
                    this.getGlobalConfig().uploadURL +
                    '/api/file/downloadFile' +
                    '?fullfilename=' +
                    xcd.fileId +
                    this.getFileExtensionWithDot(xcd.fileName) +
                    '&fileHashOrWholeFileId=' +
                    xcd.fileId
                });
              }
            });
          }
        });

        if (previewFiles.length === 0) {
          this.$message.warning('没有可预览的文件');
          return;
        }

        // 执行预览
        this.executePreview(previewFiles);
      });
    },

    // 执行预览操作的公共方法
    executePreview(previewFiles) {
      if (previewFiles.length === 0) {
        this.$message.warning('没有可预览的文件');
        return;
      }

      window.sessionStorage.previewFileData = JSON.stringify(previewFiles);
      window.sessionStorage.defaultProps = JSON.stringify({
        children: 'children',
        label: 'label'
      });
      window.sessionStorage.currentFile = previewFiles[0].id;

      window.open(
        window.location.origin +
          (window.location.pathname ? window.location.pathname : '') +
          '#/previewFile?timestamp=' +
          new Date().getTime()
      );
    },

    // 根据发票ID获取行程单信息
    getXcdByFpIds(fpIds) {
      // 参数校验
      if (!fpIds || (Array.isArray(fpIds) && fpIds.length === 0)) {
        this.$message.warning('发票ID不能为空');
        return Promise.reject(new Error('发票ID不能为空'));
      }

      // 统一处理为数组格式
      const fpIdArray = Array.isArray(fpIds) ? fpIds : [fpIds];

      // 过滤掉空值
      const validFpIds = fpIdArray.filter((id) => id && id.toString().trim());

      if (validFpIds.length === 0) {
        this.$message.warning('没有有效的发票ID');
        return Promise.reject(new Error('没有有效的发票ID'));
      }

      const params = {
        fpIds: validFpIds
      };

      return this.$api
        .formPost('/api/major/fpgl/xcd/doGetByFpId', params)
        .then((res) => {
          if (res && res.retHead && res.retHead.code === '0000000') {
            return res.retBody || [];
          } else {
            const errorMsg = res?.retHead?.message || '获取行程单失败';
            console.error('获取行程单失败:', errorMsg);
            return Promise.reject(new Error(errorMsg));
          }
        })
        .catch((error) => {
          console.error('获取行程单请求失败:', error);
          return Promise.reject(error);
        });
    },

    // 获取费用类型名称
    getFeeTypeName(feeType) {
      const typeMap = {
        air: '飞机费用',
        train: '火车费用',
        other: '其他费用',
        inCity: '市内交通'
      };
      return typeMap[feeType] || '未分类';
    },

    // 获取费用类型标签颜色
    getFeeTypeTagType(feeType) {
      const typeMap = {
        air: 'primary',
        train: 'success',
        other: 'warning',
        inCity: 'info'
      };
      return typeMap[feeType] || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.el-divider__text {
  color: #409eff !important;
  font-weight: bold;
  font-size: 16px;
}

.pctw100 {
  width: 100%;
}

.el-form-item {
  margin-bottom: 18px;
}

.invoice-count-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.invoice-count-container span {
  margin-right: 10px;
}

/* 发票信息标题行样式 */
.invoice-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
}

.invoice-header .el-divider {
  margin: 0;
  flex: 1;
}

.invoice-header .el-button {
  margin-left: 16px;
  flex-shrink: 0;
}

/* 核准补贴醒目样式 */
.examine-bt-amt {
  ::v-deep .el-form-item__label {
    color: #e6a23c !important;
    font-weight: bold !important;
    font-size: 14px !important;
  }

  ::v-deep .jh-number {
    border: 2px solid #e6a23c !important;
    border-radius: 4px;
    background-color: #fdf6ec !important;
  }

  ::v-deep .el-input__inner {
    background-color: #fdf6ec !important;
    border-color: #e6a23c !important;
    color: #e6a23c !important;
    font-weight: bold !important;
  }

  ::v-deep .el-input-group__append {
    background-color: #e6a23c !important;
    color: white !important;
    border-color: #e6a23c !important;
    font-weight: bold !important;
  }
}

/* 核准市内交通费用醒目样式 */
.examine-incity-amt {
  ::v-deep .el-form-item__label {
    color: #67c23a !important;
    font-weight: bold !important;
    font-size: 14px !important;
  }

  ::v-deep .jh-number {
    border: 2px solid #67c23a !important;
    border-radius: 4px;
    background-color: #f0f9ff !important;
  }

  ::v-deep .el-input__inner {
    background-color: #f0f9ff !important;
    border-color: #67c23a !important;
    color: #67c23a !important;
    font-weight: bold !important;
  }

  ::v-deep .el-input-group__append {
    background-color: #67c23a !important;
    color: white !important;
    border-color: #67c23a !important;
    font-weight: bold !important;
  }
}

/* 财务调整费用醒目样式 */
.finance-adjust-amt {
  ::v-deep .el-form-item__label {
    color: #409eff !important;
    font-weight: bold !important;
    font-size: 14px !important;
  }

  ::v-deep .jh-number {
    border: 2px solid #409eff !important;
    border-radius: 4px;
    background-color: #ecf5ff !important;
  }

  ::v-deep .el-input__inner {
    background-color: #ecf5ff !important;
    border-color: #409eff !important;
    color: #409eff !important;
    font-weight: bold !important;
  }

  ::v-deep .el-input-group__append {
    background-color: #409eff !important;
    color: white !important;
    border-color: #409eff !important;
    font-weight: bold !important;
  }
}
</style>
